module.exports = __webpack_public_path__ + "Lato-Medium.461b98b0328b2f5431f4.woff";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Medium.woff
// module id = ../../../../../src/assets/fonts/Lato/Lato-Medium.woff
// module chunks = styles